__turbopack_context__.v({
  "video": "Video-module-scss-module__qpiFTG__video",
});
